/**
 * Server-side OffchainAuthProvider wrapper for the poofnet environment.
 *
 * Poofnet onchain writes are signed like mainnet ones - the worker verifies the
 * signature on an unsendable approval message before committing - so signing
 * goes straight to the wrapped keypair. Only a raw submit, which needs a real
 * cluster, is refused.
 */
export class OffchainAuthProvider {
    constructor(wrappedProvider) {
        this.wrappedProvider = wrappedProvider;
    }
    async login() {
        return this.wrappedProvider.login();
    }
    async logout() {
        return this.wrappedProvider.logout();
    }
    async restoreSession() {
        return this.wrappedProvider.restoreSession();
    }
    async getNativeMethods() {
        return this.wrappedProvider.getNativeMethods();
    }
    async signMessage(message) {
        return this.wrappedProvider.signMessage(message);
    }
    async signTransaction(transaction) {
        return this.wrappedProvider.signTransaction(transaction);
    }
    /**
     * Sign and submit transaction - not supported in poofnet environment.
     * See the real providers (PhantomWalletProvider, PrivyWalletProvider, SolanaKeypairProvider)
     * for the full implementation with blockhash handling and feePayer support.
     */
    async signAndSubmitTransaction(_transaction, _feePayer) {
        throw new Error('Poofnet does not support real Solana transactions. Deploy your project to mainnet to use this feature.');
    }
}
//# sourceMappingURL=offchain-auth-provider.js.map